import React, { Component } from "react";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import Spinner from "../../lib/spinner";
import ListViewRow from "../../lib/list_view_row";
import moment from "moment";
import { If } from "react-extras";

class ShowDetailsEpisodeList extends Component {
  componentDidMount() {
    this.props.fetchEpisodesForShow(this.props.showUUID, this.props.user);
  }

  getSubtext = (publishedAt, isVisible) => {
    var publishedInFuture = publishedAt * 1000 > new Date().valueOf();
    var formattedDate = moment(publishedAt, "X").format("MMMM D, YYYY [at] h:mm a");
    if (!isVisible) {
      return `Unpublished Draft`;
    }
    if (publishedInFuture) {
      return `Draft, To Publish on ${formattedDate}`;
    }
    return `Published on ${formattedDate}`;
  };

  getColumnInfo(totalRows) {
    return [
      {
        Cell: props => {
          this.getSubtext(props.row.publishedAt, props.row.isVisible);
          return (
            <ListViewRow
              linkTo={`/shows/${props.row.showUUID}/ep/${props.row.uuid}`}
              mainText={props.row.title}
              dropUp={props.index > totalRows - 3}
              subText={this.getSubtext(props.row.publishedAt, props.row.isVisible)}
              menuItems={{
                "Episode Details": () => {
                  this.props.historyPush(`/shows/${props.row.showUUID}/ep/${props.row.uuid}`);
                },
                "Edit Episode": () => {
                  this.props.historyPush(`/shows/${props.row.showUUID}/ep/${props.row.uuid}/edit`);
                },
              }}
              historyPush={this.props.historyPush}
            />
          );
        },

        filterable: true,
        filterMethod: (filter, row) => row.title.toLowerCase().includes(filter.value),

        // This is overridden just to specify the placeholder.
        Filter: ({ filter, onChange }) => {
          return (
            <div>
              <input
                className="form-control"
                onChange={event => onChange(event.target.value)}
                value={filter ? filter.value : ""}
                placeholder="Search..."
              />
            </div>
          );
        },
      },

      // These are included because they are referenced in the 'Cell' for episode title
      // And we need them to be in props.row.*
      {
        accessor: "uuid",
        show: false,
      },
      {
        accessor: "showUUID",
        show: false,
      },
      {
        accessor: "publishedAt",
        show: false,
      },
      {
        accessor: "isVisible",
        show: false,
      },
      {
        accessor: "title",
        show: false,
      },
    ];
  }

  render() {
    var allEpisodes = [];
    if (this.props.episodeInfo) {
      for (var uuid of Object.keys(this.props.episodeInfo.episodes || {})) {
        allEpisodes.push(this.props.episodeInfo.episodes[uuid]);
      }
      allEpisodes.reverse();
    }
    // we want to overflow the containers when there are less than 5 items so that the dropdown menu
    // on each row does not get cut off by the container.
    const additionalStyle = () => ({
      ...(allEpisodes.length <= 5 && { style: { overflow: "visible" } }),
    });

    var isLoading = !this.props.episodeInfo || this.props.episodeInfo.isLoading;
    return (
      <div className="show-details-episode-list">
        <Spinner thing={true} isLoading={isLoading} />
        <If condition={Boolean(allEpisodes.length)}>
          <ReactTable
            getTbodyProps={additionalStyle}
            getTableProps={additionalStyle}
            data={allEpisodes}
            columns={this.getColumnInfo(allEpisodes.length)}
            showPagination={false}
            showPageSizeOptions={false}
            defaultPageSize={9999999}
            minRows={0}
          />
        </If>
        <If condition={!allEpisodes.length && !isLoading}>
          <div className="show-details-page__no-episode-text">
            No Episodes Yet -{" "}
            <Link to={"/shows/" + this.props.showUUID + "/ep/create"}>Create One</Link>
          </div>
        </If>
      </div>
    );
  }
}

export default ShowDetailsEpisodeList;
